import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { debounce } from 'throttle-debounce';
import { CLOSE_BUTTON_CLASS, CLOSE_BUTTON_CONTAINER_SELECTOR, CUSTOM_ROUTE_CONTROL_CLASS } from '../../constants/styles';
import { CUSTOM_ROUTE_CONTROL_STICKY_LEFT_CLASS } from '../../constants/routeControl/stickyLeftStyles';
import { ERouteControlViewType } from '../../types';
import { CUSTOM_ROUTE_CONTROL_STICKY_BOTTOM_CLASS, DEFAULT_ROUTE_CONTROL_OPTIONS, DEFAULT_ROUTE_CONTROL_STATE, MULTI_ROUTE_CONFIG } from '../../constants/routeControl';
import { getRouteControlOptions, mapRouteReferencePoints } from './helpers';
export var YRouteControl = /*#__PURE__*/function () {
  function YRouteControl(map, mapInstance, options) {
    _classCallCheck(this, YRouteControl);
    _defineProperty(this, "_controls", null);
    _defineProperty(this, "_map", void 0);
    _defineProperty(this, "_mapInstance", void 0);
    _defineProperty(this, "_options", void 0);
    _defineProperty(this, "_fixedPoints", {});
    // ----------------------------------------------------------------------------------------------------
    /** Коллбэк изменения активного маршрута, гарантирующий выполнение 1 раз */
    _defineProperty(this, "_handleActiveRouteChangeDebounced", debounce(20, this._handleActiveRouteChange));
    this._map = map;
    this._mapInstance = mapInstance;
    this._options = options;
  }
  return _createClass(YRouteControl, [{
    key: "controls",
    get: function get() {
      if (!this._controls) {
        throw new Error('Панель построения маршрута не инициализирована!');
      }
      return this._controls;
    }

    /** Открыть построение маршрута с инициализацией зависимостей */
  }, {
    key: "init",
    value: (function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var viewType,
          options,
          routePanelInstance,
          multiRoute,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              viewType = _args.length > 0 && _args[0] !== undefined ? _args[0] : ERouteControlViewType.default;
              if (!this._controls) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              options = getRouteControlOptions(viewType);
              routePanelInstance = new this._mapInstance.control.RoutePanel({
                options: options
              });
              routePanelInstance.routePanel.options.set(DEFAULT_ROUTE_CONTROL_OPTIONS);
              routePanelInstance.routePanel.state.set(DEFAULT_ROUTE_CONTROL_STATE);
              this._controls = {
                routePanel: routePanelInstance
              };
              this._map.controls.add(routePanelInstance);
              routePanelInstance.routePanel.events.add('enable', function () {
                var closeButton = document.createElement('div');
                closeButton.className = "".concat(CLOSE_BUTTON_CLASS, " ").concat(viewType);
                closeButton.dataset.testid = 'RouteControlCloseButton';
                var routePanelNode = document.querySelector(CLOSE_BUTTON_CONTAINER_SELECTOR);
                if (routePanelNode) {
                  routePanelNode.appendChild(closeButton);
                  closeButton.addEventListener('click', _this.destroy.bind(_this));
                }
              });

              // NOTE: Пока игнорируем ошибку, при корректном флоу ошибок не будет
              this._applyStyles(viewType).catch(function () {});
              _context.prev = 11;
              _context.next = 14;
              return new Promise(function (resolve, reject) {
                routePanelInstance.routePanel.getRouteAsync().then(resolve, reject);
              });
            case 14:
              multiRoute = _context.sent;
              multiRoute.events.add('activeroutechange', this._handleActiveRouteChangeDebounced.bind(this));
              multiRoute.events.add('update', this._handleRoutesUpdate.bind(this));
              multiRoute.model.events.add('requestsend', this._handleRequestSend.bind(this));
              multiRoute.options.set(MULTI_ROUTE_CONFIG);
              this._handleEventInit();
              _context.next = 26;
              break;
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](11);
              this.destroy();
              throw _context.t0;
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[11, 22]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }() // ----------------------------------------------------------------------------------------------------
    /** Установить координаты начальной точки маршрута */
    )
  }, {
    key: "setPointFrom",
    value: function setPointFrom(lat, lng) {
      var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var title = arguments.length > 3 ? arguments[3] : undefined;
      this._updateState({
        from: "".concat(lat, ", ").concat(lng),
        fromEnabled: enabled
      });
      this._fixedPoints.from = title;
    }

    // ----------------------------------------------------------------------------------------------------

    /** Установить координаты конечной точки маршрута */
  }, {
    key: "setPointTo",
    value: function setPointTo(lat, lng) {
      var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var title = arguments.length > 3 ? arguments[3] : undefined;
      this._updateState({
        to: "".concat(lat, ", ").concat(lng),
        toEnabled: enabled
      });
      this._fixedPoints.to = title;
    }

    // ----------------------------------------------------------------------------------------------------

    /** Установить тип маршрутизации */
  }, {
    key: "setRoutingMode",
    value: function setRoutingMode(mode) {
      this._updateState({
        type: mode
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Очистить состояние построения маршрута и закрыть панель */
  }, {
    key: "destroy",
    value: function destroy() {
      this._map.controls.remove(this.controls.routePanel);
      this._controls = null;
      this._handleEventDestroy();
    }

    // ----------------------------------------------------------------------------------------------------

    /** Обновить текущее состояние панели построения маршрута */
  }, {
    key: "_updateState",
    value: function _updateState(state) {
      this.controls.routePanel.routePanel.state.set(state);
    }

    // ----------------------------------------------------------------------------------------------------

    /** Применить кастомные стили к панели построения маршрута */
  }, {
    key: "_applyStyles",
    value: function _applyStyles(viewType) {
      var routePanel = this.controls.routePanel;
      var parent = routePanel.getParent();
      return new Promise(function (resolve, reject) {
        if (!parent) {
          reject(new Error('Родительский элемент для панели построения маршрута не был установлен!'));
        } else {
          parent.getChildElement(routePanel).then(function (node) {
            node.classList.add(CUSTOM_ROUTE_CONTROL_CLASS);
            if (viewType === ERouteControlViewType.stickyLeft) {
              node.classList.add(CUSTOM_ROUTE_CONTROL_STICKY_LEFT_CLASS);
            }
            if (viewType === ERouteControlViewType.stickyBottom) {
              node.classList.add(CUSTOM_ROUTE_CONTROL_STICKY_BOTTOM_CLASS);
            }
            resolve();
          }, reject);
        }
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Применить кастомные заголовки для точек маршрута */
  }, {
    key: "_applyWayPointNames",
    value: function _applyWayPointNames(multiRoute) {
      var _this2 = this;
      var points = multiRoute.getWayPoints().toArray();
      points.forEach(function (point, idx, arr) {
        var index = point.properties.get('index');

        // Применить заголовок к первой точке маршрута, когда задан заголовок точки from
        if (index === 0 && _this2._fixedPoints.from !== undefined) {
          point.properties.set('name', _this2._fixedPoints.from);
        }

        // Применить заголовок к последней точке маршрута, когда маршрут состоит хотя бы из двух точек и задан заголовок точки to
        if (index > 0 && index + 1 === arr.length && _this2._fixedPoints.to !== undefined) {
          point.properties.set('name', _this2._fixedPoints.to);
        }
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк изменения активного маршрута */
  }, {
    key: "_handleActiveRouteChange",
    value: function _handleActiveRouteChange(event) {
      if (!this._options.onActiveRouteChange) {
        return;
      }
      var yaRoute = event.originalEvent.target.getActiveRoute();
      var activeRoute = yaRoute && yaRoute.properties.getAll();
      this._options.onActiveRouteChange(activeRoute);
    }
  }, {
    key: "_handleRoutesUpdate",
    value:
    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк успешного обновления маршрута */
    function _handleRoutesUpdate(event) {
      this._applyWayPointNames(event.originalEvent.target);
      if (this._options.onRoutesUpdate) {
        var routesData = event.originalEvent.target.getRoutes().toArray();
        var routes = routesData.map(function (route) {
          return route.properties.getAll();
        });
        var wayPointsData = event.originalEvent.target.getWayPoints().toArray();
        var wayPoints = wayPointsData.map(function (point) {
          return point.properties.getAll();
        });
        var mode = this.controls.routePanel.routePanel.state.get('type');
        this._options.onRoutesUpdate({
          mode: mode,
          routes: routes,
          wayPoints: wayPoints
        });
      }

      // Обновляет активный роут после перестроения маршрута
      this._handleActiveRouteChangeDebounced(event);
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк запроса для построения маршрута */
  }, {
    key: "_handleRequestSend",
    value: function _handleRequestSend(event) {
      if (!this._options.onRequestSend) {
        return;
      }
      var _event$originalEvent = event.originalEvent,
        params = _event$originalEvent.params,
        referencePoints = _event$originalEvent.referencePoints;
      this._options.onRequestSend({
        coordinatesOrder: params.searchCoordOrder,
        mode: params.routingMode,
        points: mapRouteReferencePoints(referencePoints)
      });
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк инициализации панели построения маршрута */
  }, {
    key: "_handleEventInit",
    value: function _handleEventInit() {
      if (!this._options.onInit) {
        return;
      }
      this._options.onInit();
    }

    // ----------------------------------------------------------------------------------------------------

    /** Коллбэк закрытия панели построения маршрута */
  }, {
    key: "_handleEventDestroy",
    value: function _handleEventDestroy() {
      if (!this._options.onDestroy) {
        return;
      }
      this._options.onDestroy();
    }

    // ----------------------------------------------------------------------------------------------------
  }]);
}();